export const grayColors = {
    gray100: '#fff',
    gray200: '#f5f5f5',
    gray300: '#e6e6e6',
    gray400: '#ccc',
    gray500: '#999',
    gray600: '#666',
    gray700: '#333',
    gray800: '#000',
};
export const focusedColor = '#0D6AF5';
export const informativeColors = {
    informative200: grayColors.gray200,
    informative600: grayColors.gray600,
    informative800: grayColors.gray800,
};
export const negativeColors = {
    negative200: '#f8ebeb',
    negative600: '#d93a5a',
    negative800: '#cb2647',
};
export const noticeColors = {
    notice200: '#f8f3ed',
    notice600: '#b2830a',
    notice800: '#8d6708',
};
export const positiveColors = {
    positive200: '#f1f9f4',
    positive600: '#278c7a',
    positive800: '#147658',
};
export const mintedAccentColors = {
    accent100: grayColors.gray100,
    accent200: '#f3f4f0',
    accent300: '#eef3ec',
    accent400: '#d8dcd9',
    accent500: '#bdc8c0',
    accent600: '#497a6d',
    accent700: '#435d5b',
    accent800: '#2e3736',
};
export const mintedMarketingColors = {
    marketing800: '#b34623',
};
export const systemColors = Object.assign(Object.assign(Object.assign(Object.assign({ focused: focusedColor }, informativeColors), negativeColors), noticeColors), positiveColors);
export const borderColors = {
    borderBrand: mintedAccentColors.accent700,
    borderBrandBold: mintedAccentColors.accent800,
    borderDefault: grayColors.gray400,
    borderDisabled: grayColors.gray200,
    borderError: negativeColors.negative600,
    borderErrorBold: negativeColors.negative800,
    borderFocused: focusedColor,
    borderHover: grayColors.gray500,
    borderInverted: grayColors.gray100,
    borderPressed: grayColors.gray700,
};
export const contentColors = {
    contentAccent: systemColors.positive800,
    contentBrand: mintedAccentColors.accent700,
    contentBrandBold: mintedAccentColors.accent800,
    contentDisabled: grayColors.gray400,
    contentError: negativeColors.negative600,
    contentErrorBold: negativeColors.negative800,
    contentNotice: systemColors.notice600,
    contentNoticeBold: systemColors.notice800,
    contentPrimary: grayColors.gray700,
    contentPrimaryInvert: grayColors.gray100,
    contentSecondary: grayColors.gray500,
    contentSecondaryInvert: grayColors.gray200,
};
export const surfaceSystemColors = {
    surfaceSystemAccent: mintedAccentColors.accent300,
    surfaceSystemAccentHovere: mintedAccentColors.accent400,
    surfaceSystemDisabled: grayColors.gray200,
    surfaceSystemNull: 'transparent',
    surfaceSystemPrimary: grayColors.gray100,
    surfaceSystemPrimaryInverse: grayColors.gray700,
    surfaceSystemSecondary: grayColors.gray200,
    surfaceSystemSecondaryHover: grayColors.gray300,
    surfaceSystemSecondaryInverse: grayColors.gray800,
    surfaceSystemSubtleInverse: grayColors.gray500,
    surfaceSystemTertiaryInverse: grayColors.gray600,
};
export const surfaceSemanticColors = {
    surfaceSemanticError: negativeColors.negative600,
    surfaceSemanticErrorHover: negativeColors.negative800,
    surfaceSemanticErrorSubtle: negativeColors.negative200,
    surfaceSemanticInformative: grayColors.gray300,
    surfaceSemanticInformativeHover: grayColors.gray600,
    surfaceSemanticInformativePressed: grayColors.gray700,
    surfaceSemanticInformativeSubtle: grayColors.gray200,
    surfaceSemanticSuccess: positiveColors.positive600,
    surfaceSemanticSuccessHover: positiveColors.positive800,
    surfaceSemanticSuccessSubtle: positiveColors.positive200,
    surfaceSemanticWarning: noticeColors.notice600,
    surfaceSemanticWarningHover: noticeColors.notice800,
    surfaceSemanticWarningSubtle: noticeColors.notice200,
};
export const surfaceGrayColors = {
    surfaceGrayDefault: grayColors.gray600,
    surfaceGrayDisabled: grayColors.gray200,
    surfaceGrayHover: grayColors.gray700,
    surfaceGrayPressed: grayColors.gray800,
    surfaceGrayTrim: 'rgba(0, 0, 0, 0.5)',
};
export const textColors = {
    textBrand: mintedAccentColors.accent700,
    textBrandBold: mintedAccentColors.accent800,
    textDisabled: grayColors.gray400,
    textError: negativeColors.negative600,
    textErrorBold: negativeColors.negative800,
    textNotice: systemColors.notice600,
    textNoticeBold: systemColors.notice800,
    textPrimary: grayColors.gray700,
    textPrimaryInvert: grayColors.gray100,
    textPromo: systemColors.positive800,
    textSecondary: grayColors.gray600,
    textSecondaryInvert: grayColors.gray200,
};
export const textLinkColors = {
    textLinkEmphasized: mintedAccentColors.accent600,
    textLinkSubtle: textColors.textSecondary,
};
const baseColors = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, borderColors), contentColors), grayColors), informativeColors), mintedAccentColors), mintedMarketingColors), negativeColors), noticeColors), positiveColors), surfaceGrayColors), surfaceSemanticColors), surfaceSystemColors), textColors), textLinkColors);
/* eslint-disable deprecation/deprecation */
const colorDeprecations = {
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    accent: '#91ac4c',
    /**
     * @deprecated This color is deprecated. Use `negative800` instead.
     */
    alert: baseColors.negative800,
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    alertDark: '#a21e39',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    alertLight: '#eba9b6',
    /**
     * @deprecated This color is deprecated. Use `gray700` instead.
     */
    black: baseColors.gray700,
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    blackLight: '#5c5c5c',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    blue: '#7dd3dc',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    blueDark: '#368097',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    blueLight: '#cef0ed',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    blueLighter: '#eafaf4',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    blush: '#f2e0d5',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    blushDark: '#e4c6b1',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    blushLight: '#f8ede4',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    blushPink: '#e3adab',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    brandPrimary: '#8aad3a',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    brandPrimaryDark: '#6e8a2e',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    brandPrimaryLight: '#d0deb0',
    /**
     * @deprecated This color is deprecated. Use `gray600` instead.
     */
    darkGray: baseColors.gray600,
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    darkGreen: '#6e8a2e',
    /**
     * @deprecated This color is deprecated. Use `notice200` instead.
     */
    eggshell: baseColors.notice200,
    /**
     * @deprecated This color is deprecated. Use `negative800` instead.
     */
    error: baseColors.negative800,
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    facebook: '#1877f2',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    facebookDark: '#29487d',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    facebookLight: '#b3c2e1',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    forestGreen: '#147658',
    /**
     * @deprecated This color is deprecated. Use `notice800` instead.
     */
    gold: baseColors.notice800,
    /**
     * @deprecated This color is deprecated. Use `gray400` instead.
     */
    gray: baseColors.gray400,
    /**
     * @deprecated This color is deprecated. Use `gray400` instead.
     */
    grayBase: baseColors.gray400,
    /**
     * @deprecated This color is deprecated. Use `gray500` instead.
     */
    grayDark: baseColors.gray500,
    /**
     * @deprecated This color is deprecated. Use `gray600` instead.
     */
    grayDarker: baseColors.gray600,
    /**
     * @deprecated This color is deprecated. Use `gray300` instead.
     */
    grayLight: baseColors.gray300,
    /**
     * @deprecated This color is deprecated. Use `gray200` instead.
     */
    grayLighter: baseColors.gray200,
    /**
     * @deprecated This color is deprecated. Use `gray200` instead.
     */
    grayLightest: baseColors.gray200,
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    green: '#8aad3a',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    greenDark: '#6e8a2e',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    greenLight: '#d0deb0',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    greenLighter: '#e2eace',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    greenLightest: '#edf3e1',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    info: '#368097',
    /**
     * @deprecated This color is deprecated. Use `informative200` instead.
     */
    informative100: informativeColors.informative200,
    /**
     * @deprecated This color is deprecated. Use `gray200` instead.
     */
    lighterGray: baseColors.gray200,
    /**
     * @deprecated This color is deprecated. Use `gray300` instead.
     */
    lightGray: baseColors.gray300,
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    lightGreen: '#d0deb0',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    lightMint: '#ebf9f3',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    lightRed: '#f6d1c6',
    /**
     * @deprecated This color is deprecated. Use `notice200` instead.
     */
    lightYellow: baseColors.notice200,
    /**
     * @deprecated This color is deprecated. Use `gray500` instead.
     */
    mediumGray: baseColors.gray500,
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    mint: '#a2dbc6',
    /**
     * @deprecated This color is deprecated. Use `negative200` instead.
     */
    negative100: negativeColors.negative200,
    /**
     * @deprecated This color is deprecated. Use `notice200` instead.
     */
    notice100: noticeColors.notice200,
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    orange: '#db7b5f',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    plum: '#86504c',
    /**
     * @deprecated This color is deprecated. Use `positive200` instead.
     */
    positive100: positiveColors.positive200,
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    premium: '#368097',
    /**
     * @deprecated This color is deprecated. Use `negative800` instead.
     */
    red: baseColors.negative800,
    /**
     * @deprecated This color is deprecated. Use `negative800` instead.
     */
    redBase: baseColors.negative800,
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    redLight: '#f6d1c6',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    redLighter: '#f2c8d1',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    robinBlue: '#a6c8cc',
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    success: '#6e8a2e',
    /**
     * @deprecated This color is deprecated. Use `gray800` instead.
     */
    trueBlack: baseColors.gray800,
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    warn: '#db7b5f',
    /**
     * @deprecated This color is deprecated. Use `gray100` instead.
     */
    white: baseColors.gray100,
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    yellow: '#eecc72',
    /**
     * @deprecated This color is deprecated. Use `notice200` instead.
     */
    yellowBase: baseColors.notice200,
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    yellowLight: '#f8eac6',
};
const formColorDeprecations = {
    /**
     * @deprecated This color is deprecated. Use `gray600` instead.
     */
    addon: baseColors.gray600,
    /**
     * @deprecated This color is deprecated. Use `gray400` instead.
     */
    border: baseColors.gray400,
    /**
     * @deprecated This color is deprecated. If you need this color, ask UX for an alternative.
     */
    borderFocus: '#7dd3dc',
    /**
     * @deprecated This color is deprecated. Use `gray300` instead.
     */
    disabled: baseColors.gray300,
    /**
     * @deprecated This color is deprecated. Use `gray500` instead.
     */
    floatLabel: baseColors.gray500,
    /**
     * @deprecated This color is deprecated. Use `gray400` instead.
     */
    placeholder: baseColors.gray400,
};
/* eslint-enable deprecation/deprecation */
const colors = Object.assign(Object.assign(Object.assign({}, baseColors), colorDeprecations), formColorDeprecations);
export default colors;
